import React from 'react';
import './App.css'
import AppRoutes from "./Routes"

function App() {
  return (
    <AppRoutes></AppRoutes>
  );
}

export default App;
